import './outer_layout';
import '@pStrength';
import 'jquery-mask-plugin';
import '../modules/registration/active_campaign_webtracker';
import '../modules/registration/registration_form';
import '../modules/registration/registration_input';
import '../components/checkbox';
import '../modules/registration/password_strength';
import '../modules/registration/form_validation';
